/**
 * FRONT-1996 review M6: the takeover/hand-back routes answer a real,
 * expected 409 with a bare machine code in the JSON body (`{error:
 * "run_finished"}` / `{error:"stop_requested"}`, `src/operator/routes.ts`) —
 * `humanErrorMessage` (`~/lib/api-client`) unwraps that `error` field
 * straight into the thrown `ApiError`'s own `.message`, so without this
 * mapping the toast read "Take over failed: run_finished", a raw
 * programmer token with no article, verb or period. Shared by both
 * mutations (`use-take-over-operator-run.ts`, `use-hand-back-operator-
 * run.ts`) so the two surfaces never drift on wording for the same code.
 * Any OTHER message (a network error, a 5xx, a code this map doesn't know)
 * passes through unchanged — this is a translation for the codes we know
 * are real and expected, never a blanket rewrite of arbitrary errors.
 */

const OPERATOR_MUTATION_ERROR_SENTENCES: Record<string, string> = {
  run_finished: 'This task has already finished.',
  stop_requested: 'This task is stopping.',
};

export function describeOperatorMutationError(err: unknown): string {
  const message = err instanceof Error ? err.message : String(err);
  return OPERATOR_MUTATION_ERROR_SENTENCES[message] ?? message;
}
